import styled from 'styled-components';
import { Col } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import MQ from '../../../../attrs/mq';

export const StyledCol = styled(Col)`
  display: flex;
  margin-bottom: 0.5rem;
  ${MQ.sm`
    margin-bottom: 0rem;

    &:last-child {
      justify-content: flex-end;
      margin-bottom: 0;
    }
  `}
`;

export const InfoIcon = styled(InfoCircleOutlined)`
  margin-left: 5px;
  margin-top: 3px;
  opacity: 0.5;
`;
